import React from "react";
import { Outlet } from "react-router-dom";
import { Shell } from "../../components/Shell";

const NAV = [
  { key: "dashboard", to: "/member", label: "Dashboard" },
  { key: "qr", to: "/member/qr", label: "My QR" },
  { key: "documents", to: "/member/documents", label: "Documents" },
  { key: "profile", to: "/member/profile", label: "Profile" },
];

export default function MemberLayout() {
  return (
    <Shell nav={NAV}>
      <Outlet />
    </Shell>
  );
}
